module.exports = __webpack_public_path__ + "static/media/bank-american-express.24e4b183.svg";